<template>
  <b-modal
    ref="reportHistoryModal"
    size="md"
    :title="$t('diagnosis.btns.reportHistory')"
    centered
    modal-class="report-history-modal"
    static
    hide-footer
  >
    <div
      v-if="amendmentReports.length"
      class="pb-3"
    >
      <b-row class="px-3 mb-2">
        <b-col cols="3">
          <small>{{ $t('diagnosis.modals.report') }}</small>
        </b-col>
        <b-col cols="3">
          <small>{{ $t('diagnosis.modals.validationDate') }}</small>
        </b-col>
        <b-col>
          <small>{{ $t('diagnosis.modals.reportAuthor') }}</small>
        </b-col>
        <b-col cols="1" />
      </b-row>
      <div class="scroll-area">
        <b-row
          v-for="(amendment, index) in amendmentReports"
          :key="index"
          class="px-3"
        >
          <b-col
            v-if="amendment.original"
            cols="3"
          >
            <span>{{ $t('diagnosis.modals.originalReport') }} </span>
          </b-col>
          <b-col
            v-if="!amendment.original"
            cols="3"
          >
            <span>{{ $t('diagnosis.modals.amendmentReport') }} {{ index }}</span>
          </b-col>
          <b-col cols="3">
            <span>{{ amendment.validationDate | datetime }}</span>
          </b-col>
          <b-col>
            <span>{{ amendment.validationResponsible.fullName }}</span>
          </b-col>
          <b-col cols="1">
            <vt-loading-button
              v-if="$_canPrintCaseReport()"
              v-tooltip="$t('diagnosis.modals.viewReport')"
              class="btn__icon btn__icon--primary mx-2 p-0"
              :params="{ promise: () => showAPReport(amendment.attachment && amendment.attachment.attachmentId) }"
            >
              <i
                class="far fa-file-export"
                aria-hidden="true"
              />
            </vt-loading-button>
          </b-col>
          <b-col cols="12">
            <hr class="my-1">
          </b-col>
        </b-row>
      </div>
    </div>
    <div v-else>
      {{ $t('diagnosis.emptyReportHistory') }}
    </div>
  </b-modal>
</template>

<script>
import diagnosisCaseService from '@/modules/diagnosisModule/services/DiagnosisCaseService'
import caseInternalAttachmentService from '@/api/resources/attachment/caseInternalAttachmentService'
import { CaseOperationGuardMixin } from '@/api/operations/mixins/guards/case-operation-guard.mixin'
import { FileUtils } from '@/shared/util/file-utils'
import { HelperUtils } from '@/shared/util/helper-utils'

export default {
    name: 'ReportHistoryModal',
    mixins: [
        CaseOperationGuardMixin
    ],
    props: {
        caseLabel: { type: String }
    },
    data() {
        return {
            casId: null,
            amendmentReports: []
        }
    },
    computed: {
        labId() {
            return this.$store.getters.labId
        }
    },
    methods: {
        async show(casId) {
            this.$refs.reportHistoryModal.show()
            this.updateLoading(true)
            this.casId = casId
            const [err, response] = await this.toCall(diagnosisCaseService.getReportHistory(this.labId, casId))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.amendmentReports = response
        },
        hide() {
            this.$refs.reportHistoryModal.hide()
        },
        async showAPReport(attachmentId) {
            if (attachmentId) {
                const blob = await this.$_toCallUnique(caseInternalAttachmentService.getFile(this.labId, this.casId, attachmentId))
                if (blob) {
                    const openFileParams = {
                        blob,
                        newWindowTabTitle: `${this.caseLabel} - ${this.$tc('global.report')}`
                    }
                    FileUtils.openFile(openFileParams)
                }
            } else {
                const getCaseReportPDFParams = {
                    laboratoryId: this.labId,
                    caseId: this.casId,
                    caseLabel: this.caseLabel,
                    print: false
                }
                await HelperUtils.getCaseReportPDF(getCaseReportPDFParams)
            }
        }
    }
}
</script>

<style lang="scss">
.report-history-modal .modal-body {
    border-radius: .3rem;
}
.report-history-modal span {
    color: vt-color(dark-text);
    font-size: font-size(small);
}
.report-history-modal small {
    text-transform: uppercase;
}
.report-history-modal .scroll-area {
    min-height: 120px;
    max-height: 200px;
    overflow-y: auto;
    overflow-x: hidden;
}
</style>
